import { reactive, ref, computed, watch } from 'vue'
import store from '@/store'
import * as apiBookmark from '@/api/bookmark'

/**
 * 後で見るボタン
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * ブックマーク・後で見るID
     */
    afterId: computed({
      get: () => {
        return props.afterId
      },
      set: (value) => {
        props.afterId = value
      }
    }),

    /**
     * GA計測用class名
     */
    gaClass: computed(() => {
      return props.gaClass
    }),

    /**
     * ボタンがクリックされた場合
     */
    onClicked: () => {

      if (group1.afterId !== 0) {
        // 後で見るがONの場合

        // ブックマーク・後で見る削除APIをコール
        const params = {
          id: group1.afterId
        }

        apiBookmark
          .remove(params)
          .then(response => {
            const data = response.data
            if (data.status === 0) {
              store.dispatch('common/showToast', { text: '後で見るを削除しました。' })
              const emitData = { id: props.paramId, isAfter: false, afterId: 0 }
              if (props.paramKey === 'monograph') {
                emitData.page = props.pageNo
              }
              context.emit('onViewLaterChanged', emitData)
            }
          })
      } else {
        // 後で見るがOFFの場合

        // ブックマーク・後で見る追加APIをコール
        const params = {
          type: 2, // 2:後で見る
          key: props.paramKey,
          id: props.paramId
        }
        if (props.paramKey === 'monograph') {
          params.page = props.pageNo
        }
        apiBookmark
          .add(params)
          .then(response => {
            const data = response.data

            if (data.status === 0) {
              const afterId = data.after_id
              store.dispatch('common/showToast', { text: '後で見るに保存しました。' })
              const emitData = { id: props.paramId, isAfter: true, afterId: afterId }
              if (props.paramKey === 'monograph') {
                emitData.page = props.pageNo
              }
              context.emit('onViewLaterChanged', emitData)
            }
          })
      }
    }
  })

  return group1
}
